import { createContext } from 'react';
export var dialogContextDefaultValue = {
    dialogProps: undefined,
    setDialogProps: function (_props) { return undefined; },
};
export var DialogContext = createContext(dialogContextDefaultValue);
